import estyled from '@signal/theme/emotion'
import { appBarZIndexSelector } from '@signal/theme/selectors'
import { HEADER_CONTENT_HEIGHT } from '@signal/layouts/constants'
import ContentBase from '../Content'

export const StaticPositionedHeader = estyled.header`
  width: 100%;
  height: ${HEADER_CONTENT_HEIGHT};
`

export const StickyPositionedHeader = estyled(StaticPositionedHeader)`
  position: sticky;
  top: 0;
  z-index: ${appBarZIndexSelector};

  @media print {
    position: absolute;
  }
`

export const Content = estyled(ContentBase)`
  height: 100%;
`
